import { render, staticRenderFns } from "./FormCard.vue?vue&type=template&id=3316418b"
import script from "./FormCard.vue?vue&type=script&lang=js"
export * from "./FormCard.vue?vue&type=script&lang=js"
import style0 from "./FormCard.vue?vue&type=style&index=0&id=3316418b&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports